// 關於我們
module.exports = [
  {
    src: require('../assets/index/about_logo01.png'),
    alt: 'about_logo01.png',
    content: 'We organize domestic and overseas exhibition',
  },
  {
    src: require('../assets/index/about_logo02.png'),
    alt: 'about_logo02.png',
    content: 'We are expert in media relations',
  },
  {
    src: require('../assets/index/about_logo03.png'),
    alt: 'about_logo03.png',
    content: 'We have a team of professionals',
  },
  {
    src: require('../assets/index/about_logo04.png'),
    alt: 'about_logo04.png',
    content: 'We are proficient in integrated marketing',
  },
  {
    src: require('../assets/index/about_logo05.png'),
    alt: 'about_logo05.png',
    content: 'We provide ways of international exchanges and cooperation',
  },
  // {
  //   src: require(''),
  //   alt: '',
  //   content: '',
  // },
]



// WEBPACK FOOTER //
// ./src/plugins/about.js